export default function userHasPerm(user, perm) {
    if (!user) {
        return false;
    }
    if (user.is_superuser) {
        return true;
    }
    return user.permissions && user.permissions.includes(perm);
}
